"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.tooltip.view': 'Ver detalles de onboarding',
    'onboarding.tooltip.edit': 'Editar entrada de onboarding',
    'onboarding.tooltip.delete': 'Eliminar entrada de onboarding',
};
